import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './GenericCardScreen.scss';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import GenericCard from '../GenericCard/GenericCard';

const rootClassName = styles.rootClassName;

class GenericCardScreen extends Component {
  getGenericCardProps = () => {
    return {
      ...this.props.GenericCardProps,
      className: getMergedClassNames([
        rootClassName + '-generic-card',
        this.props.GenericCardProps.className || '',
      ]),
    };
  };

  getContainerProps = () => {
    const props = { ...(this.props.containerProps || {}) };
    return {
      ...props,
      className: getMergedClassNames([
        rootClassName + '-container',
        props.className || '',
      ]),
    };
  };

  getProps = () => {
    return {
      className: getMergedClassNames([
        rootClassName,
        this.props.className || '',
      ]),
    };
  };

  render() {
    return (
      <div {...this.getProps()}>
        <div {...this.getContainerProps()}>
          <GenericCard {...this.getGenericCardProps()}>
            {this.props.children}
          </GenericCard>
        </div>
      </div>
    );
  }
}

GenericCardScreen.propTypes = {
  containerProps: PropTypes.object,
  GenericCardProps: PropTypes.object.isRequired,
};

export default GenericCardScreen;
